export const CURRENT_SEMESTER = '23-2';

export const timeTableSelectedDefault = [
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
  [false, false, false, false, false, false, false, false],
];

export const timeTableTimeList = [
  {
    Hour: 9,
    Minute: '00',
  },
  {
    Hour: 9,
    Minute: '30',
  },
  {
    Hour: 10,
    Minute: '00',
  },
  {
    Hour: 10,
    Minute: '30',
  },
  {
    Hour: 11,
    Minute: '00',
  },
  {
    Hour: 11,
    Minute: '30',
  },
  {
    Hour: 12,
    Minute: '00',
  },
  {
    Hour: 12,
    Minute: '30',
  },
  {
    Hour: 13,
    Minute: '00',
  },
  {
    Hour: 13,
    Minute: '30',
  },
  {
    Hour: 14,
    Minute: '00',
  },
  {
    Hour: 14,
    Minute: '30',
  },
  {
    Hour: 15,
    Minute: '00',
  },
  {
    Hour: 15,
    Minute: '30',
  },
  {
    Hour: 16,
    Minute: '00',
  },
  {
    Hour: 16,
    Minute: '30',
  },
  {
    Hour: 17,
    Minute: '00',
  },
  {
    Hour: 17,
    Minute: '30',
  },
  {
    Hour: 18,
    Minute: '00',
  },
  {
    Hour: 18,
    Minute: '30',
  },
  {
    Hour: 19,
    Minute: '00',
  },
  {
    Hour: 19,
    Minute: '30',
  },
  {
    Hour: 20,
    Minute: '00',
  },
  {
    Hour: 20,
    Minute: '30',
  },
  {
    Hour: 21,
    Minute: '00',
  },
  {
    Hour: 21,
    Minute: '30',
  },
  {
    Hour: 22,
    Minute: '00',
  },
  {
    Hour: 22,
    Minute: '30',
  },
];

export const word = { attend: '출석', late: '지각', absent: '결석', excusedAbsent: '유고결석', null: '-' };

export const defaultUserAttendance = [3, 3, 3, 3, 3, 3, 3, 3];

export const INIT_DEPOSIT = 20000;

export const ATTENDANCE_STATE_NUMBER = {
  ATTEND: 0,
  LATE: 1,
  ABSENT: 2,
  NONE: 3,
  EXCUSED_ABSENT: 4,
};

export const DEPOSIT_REFUND_LIMIT = 3;

export const ATTENDANCE_FINE = {
  LATE: 3000,
  ABSENT: 5000,
};
